import PaymentMappersFactory from '../../payment/Mappers/factory.js'
import ProductEntitiesFactory from '../Entities/factory.js'
import ProductsValueObjectsFactory from '../ValueObjects/factory.js'
import ProductRawDataToProductEntityMapper from './ProductRawDataToProductEntityMapper.js'
import ProductsRawDataToVisibilityProductsListVOMapper from './ProductsRawDataToVisibilityProductsListVOMapper.js'

export default class ProductsMappersFactory {
  static productRawDataToProductEntityMapper = () =>
    new ProductRawDataToProductEntityMapper({
      entity: ProductEntitiesFactory.productEntity,
      priceRawDataToPriceVOMapper: PaymentMappersFactory.priceRawDataToPriceVOMapper(),
      taxRawDataToTaxVOMapper: PaymentMappersFactory.taxRawDataToTaxVOMapper()
    })

  static productsRawDataToVisibilityProductsListVOMapper = () =>
    new ProductsRawDataToVisibilityProductsListVOMapper({
      valueObject: ProductsValueObjectsFactory.productsListValueObject,
      mapper: ProductsMappersFactory.productRawDataToProductEntityMapper()
    })
}
